import React from "react";

export default function Login() {
	return <div>Login</div>;
}
